export const BOOKING_SLOTS = (consultationType) => ["slots", consultationType];
export const NEXT_CONSULTATION = () => ["next-consultation"];
export const WAITING_ONSITE_REQUESTS = () => ["waiting-onsite-requests"];
export const CONSULTANT_NEXT_SLOTS = () => ["consultant_next_slots"];
export const CONSULTANT_PREVIOUS_SLOTS = () => ["consultant_previous_slots"];
export const CLIENT_PREVIOUS_SLOTS = (client_id) => [
  "client_previous_slots",
  client_id,
];
